{
  "pt": {
    "question_list": {
      "actions": {
        "cancel": "Anular",
        "cancelOrder": "Cancelar",
        "delete": "Eliminar",
        "deleteMultipleQuestionLists": "Apagar...",
        "delete_cancel": "Cancelar",
        "edit": "Editar",
        "new": "Lista de FAQ",
        "reorderQuestions": "Reordenar perguntas",
        "save": "Guardar",
        "saveOrder": "Guardar",
        "submit": "Criar",
        "tickBoxesDeletion": "Assinale as caixas de verificação das perguntas frequentes que pretende eliminar e, em seguida, prima o botão acima para confirmar ou cancelar a eliminação."
      },
      "attributes": {
        "description": "Descrição",
        "name": "Nome",
        "question_list": "FAQ"
      },
      "labels": {
        "allUnits": "Todas as unidades",
        "descriptionOptional": "Descrição (facultativa)",
        "editFAQ": "Editar FAQ",
        "faq": "FAQ",
        "faq_all_projects": "FAQs todos os projectos",
        "info": "Tem uma pergunta sobre a sua casa? Fique atento às perguntas mais frequentes e às suas respostas!",
        "questions": " Sem perguntas | 1 pergunta | {count} Perguntas",
        "questions_count": "Perguntas",
        "showQuestionListFor": "Mostrar FAQ's para",
        "title": "Perguntas mais frequentes"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Aqui encontra respostas a perguntas gerais ou a perguntas feitas por outros.",
            "title": "Perguntas mais frequentes"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Forneça respostas a perguntas gerais que os seus clientes possam ter.",
            "title": "Crie a sua primeira lista de FAQ"
          }
        }
      },
      "toasts": {
        "create": "Lista de FAQ criada",
        "delete": "Lista de FAQ eliminada",
        "update": "Lista de FAQ actualizada"
      },
      "validation": {
        "needName": "Título necessário",
        "selectQuestionList": "Selecionar pelo menos 1 FAQ"
      }
    }
  }
}
